module.exports = __webpack_public_path__ + "static/media/success.60d25de3.svg";